import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { PanelStyle } from './../../../../styles'
import Base from './Base'
import Challenge from './Challenge'
import {Search} from '../../../Pages/container'
import {ArrowDrop} from '../../../../components'

class Panel extends Component {
  state = {
    lastColor: '',
    panelContent: {},
    load: false,
  }

  componentWillReceiveProps({content}){
    if (content !== '') {
      const nArr = ['', 'challenge', 'search']
      this.setState({ lastColor: content, load: false })
      this.timeout = setTimeout(() => {
        this.setState({
          load: true,
          panelContent: {
            id: content,
            push: nArr.indexOf(content) === -1 ? this.props.menu[content].push : '',
            categories: nArr.indexOf(content) === -1 ? this.props.menu[content].categories: '', 
          }
        })
      }, 300)
    }
  }

  render() {
    const { content, open, isMobile, isLoad } = this.props
    const { lastColor, panelContent, load } = this.state
    return (
      <div className={`panel ${ PanelStyle(lastColor !== 'challenge' ? 'black' : 'white', open, isMobile, isLoad) }`}>
        <div className='panel-transition'>
          {
            content === 'challenge' && <Challenge load={load} />
          }
          {
            content === 'search' && <Search load={load} isPanel home={false} />
          }
          {
            content !== 'challenge' && content !== 'search' && <Base type={content} push={panelContent.push} categories={panelContent.categories} load={load} />
          }
        </div>
      </div>
    )
  }
}

Panel.propTypes = {
  content: PropTypes.string,
  open: PropTypes.bool,
}

export default connect(
  ({ Session }) => ({
    menu: Session.menu,
  })
)(Panel)


// WEBPACK FOOTER //
// ./src/scenes/Layout/BaseLayout/Panel/index.js